import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import {
  isPrintQuestionSheet,
  showPrintQuestionSheet,
  showPrintOptionsSheet,
  setSaveVpcSheetOpenedFromPrint
} from 'ducks/sheets';
import Title, { HeadingType } from 'ui/Typography/Title';
import { useIntl } from 'react-intl';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import Button from '@ingka/button';
import Body from 'ui/Typography/Body';
import { showSaveVpcSheet } from 'ducks/sheets';
import { showHamburgerMenu } from 'ducks/layout';
import { useAppDispatch } from 'ducks/hooks';
import PrintQuestionImage from './PrintQuestionImage.jpeg';
import Modal, { ModalFooter, ModalHeader, ModalBody, Sheets } from '@ingka/modal';
import { isMobile } from 'utils/platform';
import media from 'ui/media';
import theme from 'ui/theme';

const PrintWrapper = styled.div`
  @media print {
    visibility: hidden;
  }
`;

const StyledModal = styled(Modal)`
  @media print {
    visibility: hidden;
  }
`;

const Image = styled.img``;

const ImageWrapper = styled.div`
  display: flex;
  padding-bottom: 1rem;
  padding-top: 1rem;
  ${media.mobile`
    padding-top: 1rem;
  `}
`;

const TitleWrapper = styled.div`
  ${media.mobile`
    width: 100%;
    padding: 0.5rem 0;
  `}
`;

const PrintQuestionSheet = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const visible = useSelector(isPrintQuestionSheet);

  const onClose = () => {
    dispatch(showPrintQuestionSheet(false));
    setTimeout(() => dispatch(showHamburgerMenu()), 10);
  };

  const onPrint = () => {
    dispatch(showPrintQuestionSheet(false));
    dispatch(showPrintOptionsSheet(true));
  };

  const onShareDesign = () => {
    dispatch(showPrintQuestionSheet(false));
    dispatch(setSaveVpcSheetOpenedFromPrint(true));
    dispatch(showSaveVpcSheet(true));
  };

  return (
    <PrintWrapper>
      <StyledModal
        data-testid="print-question-sheet"
        visible={visible}
        handleCloseBtn={onClose}
        style={{ zIndex: theme.zIndex.modal, transition: 'none' }}
      >
        <Sheets
          title={formatMessage({ id: 'storageone.printMessageTitle' })}
          header={
            <ModalHeader
              data-testid="modal-header-print-question-sheet"
              ariaCloseTxt={formatMessage({ id: 'storageone.closeButton' })}
            />
          }
          footer={
            <ModalFooter stacked renderBorder reverse={isMobile()}>
              <Button
                text={formatMessage({ id: 'storageone.printBtnShareDesign' })}
                onClick={onShareDesign}
                type="primary"
                data-testid="print-question-sheet-share-design-btn"
              ></Button>
              <Button
                text={formatMessage({ id: 'storageone.printBtnYes' })}
                onClick={onPrint}
                type="secondary"
                data-testid="print-question-sheet-print-btn"
              ></Button>
            </ModalFooter>
          }
        >
          <ModalBody style={{ paddingTop: '0px' }}>
            <TitleWrapper>
              <Title
                mb="l"
                type={ThemeFontStyleTypeEnum.headingMedium}
                heading={HeadingType.HeadingTwo}
              >
                {formatMessage({ id: 'storageone.printMessageTitle' })}
              </Title>
            </TitleWrapper>
            <Body type={ThemeFontStyleTypeEnum.bodyMedium}>
              {formatMessage({ id: 'storageone.printMessageBody' })}
            </Body>
            <ImageWrapper>
              <Image
                src={PrintQuestionImage}
                alt={formatMessage({ id: 'storageone.printMessageTitle' })}
              />
            </ImageWrapper>
          </ModalBody>
        </Sheets>
      </StyledModal>
    </PrintWrapper>
  );
};

export default PrintQuestionSheet;
